import { Component, HostListener, OnInit } from '@angular/core';
import { AadhaarBasedAuthenticationService } from './shared/services/aadhaar/aadhaar.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'registration-portal';
  sender ="mainapp";

  constructor(
    private aadhaarService: AadhaarBasedAuthenticationService
  ){}


  ngOnInit(): void {
    this.aadhaarService.loadAadhaarRequirement()
  }

  @HostListener('paste', ['$event']) blockPaste(e: KeyboardEvent) {
    console.log ("paste is not allowed");
    e.preventDefault();
  }

  @HostListener('copy', ['$event']) blockCopy(e: KeyboardEvent) {
    console.log ("copy is not allowed")
    e.preventDefault();
  }

  @HostListener('cut', ['$event']) blockCut(e: KeyboardEvent) {
    e.preventDefault();
  }
  
}
